import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { StoreService } from "../../Services/StoreService";
import { toast } from "react-toastify"
import Loader from "../../Components/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const EditStore = () => {
  const history = useHistory();
  const [togglePassword, setTogglePassword] = useState(false)
  const [loader, setLoader] = useState();


  const getDetail = history.location.state

  const formik = useFormik({
    initialValues: {
      store_name: getDetail && getDetail.store_name,
      store_email: getDetail && getDetail.store_email,
      store_password: getDetail && getDetail.store_password,
      contact_person: getDetail && getDetail.contact_person,
      address: getDetail && getDetail.address,
      phone_number: getDetail && getDetail.phone_number,
      store_designation: getDetail && getDetail.store_designation

    },

    validationSchema: Yup.object({
      store_email: Yup.string().required("Required"),
      store_name: Yup.string().required("Required"),
      store_password: Yup.string().required("Required"),
      contact_person: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      phone_number: Yup.string().required("Required"),
      store_designation: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoader(true)
      let postData = {
        ...values,
        store_email:values.store_email.toLowerCase()
      };
      postData.id = getDetail._id;
      StoreService.updateStore(postData).then(res => {
        if (res.status) {
          toast.success(res.message);
          setLoader(false)
          history.goBack();
        } else {
          setLoader(false)
          toast.error(res.message)
        }
      })
    },
  });



  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <form className="control-form" autocomplete="off">
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Store Name</label>
                  {/* </div> */}
                  {/* <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.store_name
                        ? !formik.errors.store_name
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("store_name")}
                    placeholder="Enter Store Name"
                  />
                  {formik.touched.store_name && formik.errors.store_name ? (
                    <div className="text-danger">
                      {formik.errors.store_name}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label"> Contact Number</label>
                  {/* </div> */}
                  {/* <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.phone_number
                        ? !formik.errors.phone_number
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("phone_number")}
                    placeholder="Enter Contact Number"
                  />
                  {formik.touched.phone_number && formik.errors.phone_number ? (
                    <div className="text-danger">
                      {formik.errors.phone_number}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label"> Store Email</label>
                  {/* </div>
                <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.store_email
                        ? !formik.errors.phone_number
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("store_email")}
                    placeholder="Enter Email"
                  />
                  {formik.touched.store_email && formik.errors.store_email ? (
                    <div className="text-danger">
                      {formik.errors.store_email}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label"> Address</label>
                  {/* </div>
                <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.address
                        ? !formik.errors.address
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("address")}
                    placeholder="Enter Address"
                  />
                  {formik.touched.address && formik.errors.address ? (
                    <div className="text-danger">{formik.errors.address}</div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label"> Contact Person</label>
                  {/* </div>
                <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.contact_person
                        ? !formik.errors.contact_person
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("contact_person")}
                    placeholder="Enter Contact Name"
                  />
                  {formik.touched.contact_person &&
                    formik.errors.contact_person ? (
                    <div className="text-danger">
                      {formik.errors.contact_person}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label"> Designation</label>
                  {/* </div>
                <div> */}
                  <input
                    className={
                      "form-control" +
                      (formik.touched.store_designation
                        ? !formik.errors.store_designation
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("store_designation")}
                    placeholder="Enter Designation"
                  />
                  {formik.touched.store_designation &&
                    formik.errors.store_designation ? (
                    <div className="text-danger">
                      {formik.errors.store_designation}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Store Password</label>

                  <div className="d-flex">
                    <input
                      className={
                        "form-control no-border-right no-border-end" +
                        (formik.touched.store_password
                          ? !formik.errors.store_password
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("store_password")}
                      placeholder="Enter Password"
                      type={togglePassword ? "text" : "password"}
                      autocomplete="new-password"
                    />
                    <button type="button" className="btn-primary" onClick={() => setTogglePassword(!togglePassword)}>
                      {
                        togglePassword ?
                          <FaEye />
                          :
                          <FaEyeSlash />
                      }
                    </button>
                  </div>

                </div>

                <div>
                  {formik.touched.store_password &&
                    formik.errors.store_password ? (
                    <div className="text-danger">
                      {formik.errors.store_password}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
    </div>
  );
};
